import { defaultState } from './defaultState';
import type { FetchSuccessPayload, RedirectPayload, SportsSeoState } from './types';

export const reducers = {
  'cms/fetchPage': () => ({ ...defaultState }),
  fetchWidgetDataSuccess: (state: SportsSeoState, payload: FetchSuccessPayload): SportsSeoState => {
    if (payload.expectedPath && payload.expectedPath !== payload.actualPath) {
      return {
        ...state,
        redirect: { statusCode: 301, url: payload.expectedPath }
      };
    }

    return {
      ...state,
      tokens: payload.tokens,
      alternates: payload.alternates,
      hasPreloaded: true
    };
  },
  widgetRedirect: (state: SportsSeoState, payload: RedirectPayload) => ({
    ...state,
    redirect: payload.redirect,
    hasPreloaded: true
  })
};
